// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4cbd5aef] .el-dialog--center .el-dialog__body{text-align:center;vertical-align:middle}[data-v-4cbd5aef] .el-image__error{width:15.625rem;height:15.625rem}", ""]);
// Exports
module.exports = exports;
